import { styled } from '@vw-marketing/us-components';

export const LabelTextWrapper: any = styled.div`
  padding-bottom: 20px;
  padding-top: 2px;
  margin-top: 13px;
`;

export const DescriptionWrapper: any = styled.div`
  padding-bottom: 32px;
`;

export const NoRecallWrapper: any = styled.div`
  border-bottom: solid 1px #dfe4e8;
  margin-bottom: 27px;
`;

export const StyledStrong: any = styled.strong`
  color: inherit;
`;
